import api from '@/shared/api/base-api';

export const yandexApi = {
  getGeocode: (params: any) =>
    api.get('/v1/map/geocoder', {
      params: {
        ...params,
        geocode: params.geocode,
        format: 'json',
        lang: 'ru_RU',
        sco: 'latlong',
        results: 5,
        type: 'geo,biz',
        ll: params.region,
        spn: '6.5,6.5',
        uri: params.uri,
        rspn: 1,
      },
    }),

  getSuggest: (params: any, region = '71.392727, 42.899664') =>
    api.get('/v1/map/suggest', {
      params: {
        ...params,
        text: params.text,
        lang: 'ru_RU',
        results: 5,
        types: 'geo,biz',
        ll: region,
        spn: '6.5,6.5',
        attrs: 'uri',
      },
    }),
};

export const apikeyService = {
  getList: (params: any) => api.get('/v2/api-keys-ids', { params }),
  update: (id: string) => api.put(`/v2/api-keys/${id}`),
};
